export default __webpack_public_path__ + "static/media/SemanaNordica_Agenda_Miercoles_scroll.b1c8e983.png";